/**
 * Pagina di errore autenticazione (sessione scaduta / token invalido).
 */
import { Link } from '@tanstack/react-router';
import {
  Anchor,
  Badge,
  Button,
  Card,
  Center,
  Container,
  Group,
  List,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { IconCheck, IconLogin, IconShieldOff } from '@tabler/icons-react';

interface AuthErrorPageProps {
  reason?: string;
}

export function AuthErrorPage({ reason }: AuthErrorPageProps) {
  return (
    <Center mih="100vh">
      <Container size="sm" w="100%">
        <Stack align="center" gap="lg" ta="center">
          <ThemeIcon size={96} radius="50%" variant="light" color="orange">
            <IconShieldOff size={56} />
          </ThemeIcon>
          <Title order={2} fw={500}>Sessione scaduta</Title>
          <Text c="dimmed" maw={460}>
            La tua sessione di lavoro è terminata oppure le credenziali non sono più valide.
            Per motivi di sicurezza è necessario effettuare nuovamente l'accesso.
          </Text>

          {reason && (
            <Badge variant="light" color="gray" size="lg">
              Dettaglio: {reason}
            </Badge>
          )}

          <Card withBorder padding="md" radius="md" maw={460} w="100%">
            <Text size="sm" fw={500} mb="xs" ta="left">Cosa succede ora?</Text>
            <List
              spacing="xs"
              size="sm"
              icon={
                <ThemeIcon color="green" size="sm" radius="xl" variant="light">
                  <IconCheck size={12} />
                </ThemeIcon>
              }
              style={{ textAlign: 'left' }}
            >
              <List.Item>Le modifiche non salvate potrebbero essere andate perse.</List.Item>
              <List.Item>Effettuando il login le riprenderai dove le hai lasciate.</List.Item>
              <List.Item>I tuoi dati restano al sicuro.</List.Item>
            </List>
          </Card>

          <Group>
            <Button
              component={Link}
              to="/login"
              leftSection={<IconLogin size={18} />}
              size="md"
              variant="filled"
            >
              Torna al login
            </Button>
          </Group>

          <Text size="xs" c="dimmed">
            Problemi di accesso?{' '}
            <Anchor href="mailto:supporto@maestrale.it" size="xs">supporto@maestrale.it</Anchor>
          </Text>
        </Stack>
      </Container>
    </Center>
  );
}
